const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRemark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9 13H15",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9H13",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 14,
    height: 17,
    rx: 2,
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3V5",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3V5",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3V5",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemark);
export default __webpack_public_path__ + "static/media/IconRemark.36c1351df40ca9fcfe4f33eeb7c23b67.svg";
export { ForwardRef as ReactComponent };